import axios from "axios";

const API = axios.create({
  baseURL: "https://homefoods-backend-production.up.railway.app/api",
});

// ===============================
// Attach JWT Token
// ===============================
API.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

// ===============================
// Privacy Settings
// ===============================

export const getPrivacySettings = async () => {
  const response = await API.get("/provider-settings/privacy");
  return response.data;
};

export const updatePrivacySettings = async (settings) => {
  const response = await API.put(
    "/provider-settings/privacy",
    settings
  );

  return response.data;
};

// ===============================
// Preferences
// ===============================

export const getPreferences = async () => {
  const response = await API.get(
    "/provider-settings/preferences"
  );

  return response.data;
};

export const updatePreferences = async (preferences) => {
  const response = await API.put(
    "/provider-settings/preferences",
    preferences
  );

  return response.data;
};

// ===============================
// Security
// ===============================

export const changePassword = async (data) => {
  const response = await API.put(
    "/provider-settings/change-password",
    data
  );

  return response.data;
};

export const changeEmail = async (data) => {
  const response = await API.put(
    "/provider-settings/change-email",
    data
  );

  return response.data;
};

export const changePhone = async (data) => {
  const response = await API.put(
    "/provider-settings/change-phone",
    data
  );

  return response.data;
};

export const logoutAllDevices = async () => {
  const response = await API.post(
    "/provider-settings/logout-all"
  );

  return response.data;
};

// ===============================
// Danger Zone
// ===============================

export const pauseBusiness = async () => {
  const response = await API.put(
    "/provider-settings/pause"
  );

  return response.data;
};

export const resumeBusiness = async () => {
  const response = await API.put(
    "/provider-settings/resume"
  );

  return response.data;
};

export const deleteAllFoods = async () => {
  const response = await API.delete(
    "/provider-settings/delete-foods"
  );

  return response.data;
};
export default API;